// TODO: Need to look on international currency also
export interface FormatPriceOptions {
	currency?: string;
	withSeperator?: boolean;
	decimalNeeded?: boolean;
	decimalDigits?: number;
}
export const formatPrice = (
	price: number,
	formatOptions?: FormatPriceOptions,
): string => {
	const {
		currency = 'INR',
		withSeperator = true,
		decimalNeeded = false,
		decimalDigits = 2,
	} = formatOptions || {};
	if (decimalDigits < 0 || typeof price !== 'number') return '';

	const formatter = new Intl.NumberFormat('en-IN', {
		style: 'currency',
		currency: currency,
		useGrouping: withSeperator,
		minimumFractionDigits: decimalNeeded ? decimalDigits : 0,
		maximumFractionDigits: decimalNeeded ? decimalDigits : 0,
	});

	return formatter.format(price).replace(/\s/g, '');
};
